import { Client, Databases, Account, ID, Query } from 'appwrite';

const client = new Client()
  .setEndpoint(import.meta.env.VITE_APPWRITE_ENDPOINT || 'https://appwrite.chargedesk.de/v1')
  .setProject(import.meta.env.VITE_APPWRITE_PROJECT_ID || '69f92be900208208e766');

export const databases = new Databases(client);
export const account = new Account(client);
export const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID || 'gamelounge_db';

export { ID, Query };
export default client;
